import type { IColumnsConfig } from '@shared/table/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { MODULE } from '@modules/types';

export type CustomizeTableInitialState = Partial<
  Record<MODULE, null | IColumnsConfig>
>;

const initialState: CustomizeTableInitialState = {
  [MODULE.PLAYER_BONUS]: null,
  [MODULE.PLAYER_CODES]: null,
  [MODULE.PLAYER_OFFERS]: null,
  [MODULE.CAMPAIGN_MONITOR]: null,
  [MODULE.CAMPAIGN_ACTIVITY]: null,
};

const customizeTableSlice = createSlice({
  initialState,
  name: 'customizeTable',
  reducers: {
    getColumnsConfig(state) {
      return state;
    },
    setColumnsConfig(
      state,
      action: PayloadAction<{
        [key in MODULE]?: CustomizeTableInitialState[key];
      }>
    ) {
      const payload = action.payload;
      for (const [module, config] of Object.entries(payload)) {
        const moduleKey = module as MODULE;
        state[moduleKey] = config ?? null;
      }
    },
  },
});

export const { setColumnsConfig, getColumnsConfig } =
  customizeTableSlice.actions;

export default customizeTableSlice.reducer;
